import React from "react";
import { applications } from "../../data/mock";
import { getIcon } from "../../data/iconMap";
import SectionHeading from "../ui-custom/SectionHeading";
import GlassCard from "../ui-custom/GlassCard";
import Reveal from "../ui-custom/Reveal";

const ApplicationsSection = () => {
  return (
    <section className="relative py-24 md:py-28 px-6">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Domain Capabilities"
          title="Applications We Power"
          subtitle="Our equipment supports critical infrastructure across the full spectrum of the electrical grid — from generation to the last mile."
        />
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {applications.map((app, i) => {
            const Icon = getIcon(app.icon);
            return (
              <Reveal key={app.title} delay={i * 0.05}>
                <GlassCard tilt className="p-6 md:p-7 h-full flex flex-col items-center text-center gap-4 cursor-default">
                  <span className="w-14 h-14 rounded-xl flex items-center justify-center bg-qcyan/10 border border-qcyan/25">
                    <Icon size={26} className="text-qcyan" />
                  </span>
                  <h3 className="font-display font-semibold text-sm md:text-base text-foreground tracking-wide">{app.title}</h3>
                </GlassCard>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ApplicationsSection;
